export default __webpack_public_path__ + "static/media/ntislogo-icon.5d18563f.svg";